import { CustomImage, CustomModal, Text } from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import '@src/styles/managementUser/noteModal.scss';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

const NoteModal = ({ modalVisible, handleModalVisible }) => {
    const handleClose = useCallback(
        (e) => {
            e.preventDefault();
            handleModalVisible(false);
        },
        [handleModalVisible],
    );

    return (
        <CustomModal
            className="note-modal"
            maskClosable={false}
            footer={false}
            title={'Not'}
            visible={modalVisible}
            onCancel={handleClose}
            closeIcon={<CustomImage src={modalClose} />}
        >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus volutpat, leo sit amet
            vulputate condimentum, augue lectus pharetra nisi, at viverra metus ex non magna. Pellentesque
            nunc tortor, sollicitudin non lacinia sed, vehicula sed quam. Maecenas sollicitudin mauris
            dolor, sed pellentesque dolor porta consectetur. Praesent facilisis efficitur posuere.
            <br />
            <br />
            <Text t="quisqueFinibusVulputateBibendumInOrnareTortorSit" />
        </CustomModal>
    );
};

NoteModal.propTypes = {
    modalVisible: PropTypes.bool.isRequired,
    handleModalVisible: PropTypes.func.isRequired,
};

export default NoteModal;
